module.exports = __webpack_public_path__ + "static/media/natureswall3.6d16e052.jpg";